import { FilterSelection } from '@/scopes/prices/domain/filters/types'
import { ParsedInitialState } from '@/scopes/prices/infrastructure/parser/pricesFilterParserWithInitState'
import { PricesState } from '@/scopes/prices/infrastructure/store'
import { QueryParametersToStateMapper } from '@/scopes/prices/infrastructure/types'

export type PricesStateWithMandatoryFilterSelection = Partial<PricesState> & { filterSelection: FilterSelection }

export type PricesQueryParameterToStateMapper = QueryParametersToStateMapper<{ filterSelection: FilterSelection } | PricesStateWithMandatoryFilterSelection, FilterSelection | ParsedInitialState>

export function createPricesQueryParametersToStateMapper(deepLinkingEnabled: boolean): PricesQueryParameterToStateMapper {
  function getToState() {
    return (queryParameters: FilterSelection) => ({
      filterSelection: queryParameters,
    })
  }

  function getToStateWithInitialState() {
    return (queryParameters: ParsedInitialState) => {
      const { stateSelection, ...filterSelection } = queryParameters
      return {
        filterSelection,
        stateSelection,
      }
    }
  }

  function getToParameters() {
    return ({ filterSelection }: { filterSelection: FilterSelection }) => filterSelection
  }

  function getToParametersWithInitialState() {
    return (parameters: PricesStateWithMandatoryFilterSelection) => {
      const { selectedPriceId, selectedRooms, filterSelection, selectedOutboundRouteId, selectedInboundRouteId, roomsResponse } = parameters

      const roomsLength = roomsResponse?.roomGroups?.length ?? 0

      const room = Array.from({ length: roomsLength }).map((_, i) => {
        return selectedRooms && selectedRooms[i + 1] ? `${selectedRooms[i + 1]}` : 'empty'
      }).join(',')

      return {
        ...filterSelection,
        selectedPriceId,
        room,
        selectedOutboundRouteId,
        selectedInboundRouteId,
      }
    }
  }

  return {
    toState: deepLinkingEnabled ? getToStateWithInitialState() : getToState(),
    toParameters: deepLinkingEnabled ? getToParametersWithInitialState() : getToParameters(),
  }
}
